import Header from '../../Components/Header/Header';
import Hero from '../../Components/Hero/Hero';
import Sistemas from '../../Components/Sistemas/Sistemas';
import SobDemanda from '../../Components/SobDemanda/SobDemanda';
import QuemSomos from '../../Components/QuemSomos/QuemSomos';
import Contato from '../../Components/Contato/Contato';
import Footer from '../../Components/Footer/Footer';
import useRevelar from '../../hooks/useRevelar';

function Home() {
    useRevelar();

    return (
        <>
            <Header />
            <main>
                <Hero />
                <Sistemas />
                <SobDemanda />
                <QuemSomos />
                <Contato />
            </main>
            <Footer />
        </>
    );
}

export default Home;
